/* eslint-disable no-extend-native */
import { camelCase, isObject } from "lodash";

const _global = (window /* browser */ || global) /* node */ as any;

const transformValue = (value: any): any => {
    if (Array.isArray(value)) {
        return value.toCamelCase();
    }
    if (isObject(value)) {
        return toCamelCaseObject(value);
    }
    return value;
};

_global.toCamelCaseObject = function <T>(source: any) {
    if (Array.isArray(source) && typeof source !== "string") {
        return source.toCamelCase<T>();
    }

    const camelCaseObject: Record<string, any> = {};
    for (let key in source) {
        camelCaseObject[camelCase(key)] = transformValue(source[key]);
    }

    return camelCaseObject as T;
};

Array.prototype.toCamelCase = function <T = any>() {
    const camelCaseObject: T[] = [];
    for (let obj of this) {
        camelCaseObject.push(isObject(obj) ? toCamelCaseObject<T>(obj) : obj);
    }

    return camelCaseObject;
};
